module.exports = __webpack_public_path__ + "static/img/product_2.88393c62.png";